export const AUTH_MODAL_PATHS = [
  "/log-in",
  "/sign-up",
  "/forgot-password",
  "/otp-verification",
  "/reset-password",
];

export const buildAuthModalState = (location, extraState = {}) => {
  const backgroundLocation =
    location?.state?.backgroundLocation || location || null;

  return {
    ...location?.state,
    ...extraState,
    backgroundLocation,
  };
};
